import { Icon } from "@iconify/react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { httpsCallable } from "firebase/functions";
import { useRef, useState } from "react";
import editFill from "@iconify/icons-eva/edit-fill";
import { Link as RouterLink } from "react-router-dom";
import activityOutline from "@iconify/icons-eva/activity-outline";
import moreVerticalFill from "@iconify/icons-eva/more-vertical-fill";
import deleteOutline from "@iconify/icons-eva/trash-2-outline";
// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db, auth, app, functions } from "../../../Firebase/firebase";

// ----------------------------------------------------------------------

// Modal Styles
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "5px",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
};

export default function UserMoreMenu2({ transactionId, status, uid }) {
  const userUID = uid;
  const orderId = transactionId;
  const [orderStatus, setOrderStatus] = useState(status);
  const [updateAlert, setUpdateAlert] = useState("");
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [pauseReason, setPauseReason] = useState("");
  const [showPauseReason, setShowPauseReason] = useState(false);

  // Modal states

  const [open, setOpen] = useState(false);

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    setOrderStatus(newStatus);
    setShowPauseReason(newStatus === "paused");
  };

  const handleUpdate = async () => {
    const adminRef = doc(db, `users/${userUID}/orders`, orderId);
    await updateDoc(adminRef, {
      status: orderStatus,
      ...(orderStatus === "paused" ? { pauseReason } : {}),
    })
      .then(() => {
        setUpdateAlert("Order status has been updated");
        if (orderStatus !== "paused") {
          setPauseReason("");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setUpdateAlert("");
    setOrderStatus(status);
  };

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this order?")) {
      const orderRef = doc(db, `users/${userUID}/orders`, orderId);
      await deleteDoc(orderRef)
        .then(() => {
          setIsOpen(false);
        })
        .catch((err) => {
          console.error("Error deleting order:", err);
          alert("Error deleting order");
        });
    }
  };

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: "100%" },
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          component={RouterLink}
          to="#"
          sx={{ color: "text.secondary" }}
          onClick={handleOpen}
        >
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary="Edit Status"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <Box component="form" sx={style} noValidate autoComplete="off">
              <div style={{ margin: "0 0 5px 0", textAlign: "center" }}>
                {updateAlert && (
                  <Alert severity="success">
                    <AlertTitle>Success</AlertTitle>
                    {updateAlert}
                  </Alert>
                )}

                <FormControl
                  fullWidth
                  style={{ margin: "0 0 15px 0", width: "90%" }}
                >
                  <InputLabel id="demo-simple-select-label">
                    Select status
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Select transaction type"
                    value={orderStatus}
                    onChange={handleStatusChange}
                  >
                    <MenuItem value="dispatched">Dispatched</MenuItem>
                    <MenuItem value="departed">Departed</MenuItem>
                    <MenuItem value="destination">Destination</MenuItem>
                    <MenuItem value="delivered">Delivered</MenuItem>
                    <MenuItem value="paused">Paused</MenuItem>
                  </Select>
                </FormControl>

                {showPauseReason && (
                  <TextField
                    fullWidth
                    label="Reason for pause"
                    multiline
                    rows={3}
                    value={pauseReason}
                    onChange={(e) => setPauseReason(e.target.value)}
                    style={{ margin: "0 0 15px 0", width: "90%" }}
                    required
                    error={orderStatus === "paused" && !pauseReason}
                    helperText={
                      orderStatus === "paused" && !pauseReason
                        ? "Reason is required when pausing"
                        : ""
                    }
                  />
                )}
              </div>

              <Button variant="contained" onClick={() => handleUpdate()}>
                Update
              </Button>
            </Box>
          </Fade>
        </Modal>

        <MenuItem
          component={RouterLink}
          to={"oderDetails/" + orderId}
          sx={{ color: "text.secondary" }}
          // onClick={handleOpen}
        >
          <ListItemIcon>
            <Icon icon={activityOutline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary="Edit Details"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>

        <MenuItem sx={{ color: "error.main" }} onClick={handleDelete}>
          <ListItemIcon>
            <Icon icon={deleteOutline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary="Delete Order"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>
      </Menu>
    </>
  );
}
